import React from 'react';
import { motion } from 'framer-motion';
export function ContentSection() {
  return <section className="bg-white py-16 px-4" data-id="element-29">
      <div className="max-w-5xl mx-auto" data-id="element-30">
        <div className="text-center mb-12" data-id="element-31">
          <motion.h2 className="text-3xl md:text-5xl font-black text-brand-darkGreen mb-4" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-32">
            🍽️ QUÉ VAS A ENCONTRAR
          </motion.h2>
          <motion.p className="text-xl md:text-2xl font-bold text-brand-green" initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} data-id="element-33">
            📘 Dentro del e-book:
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16" data-id="element-34">
          {/* Card 1 */}
          <motion.div className="bg-brand-cream rounded-2xl p-8 shadow-lg border border-brand-beige relative overflow-hidden" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} data-id="element-35">
            <div className="absolute top-0 left-0 w-full h-2 bg-brand-orange" data-id="element-36"></div>
            <h3 className="text-2xl font-bold text-brand-darkGreen mb-6 flex items-center gap-2" data-id="element-37">
              <span data-id="element-38">🥐</span> DESAYUNOS Y MERIENDAS
            </h3>
            <ul className="space-y-3 mb-6 text-lg font-medium text-gray-700" data-id="element-39">
              <li className="flex items-center gap-2" data-id="element-40">
                <span className="w-2 h-2 rounded-full bg-brand-orange" data-id="element-41"></span>{' '}
                muffins
              </li>
              <li className="flex items-center gap-2" data-id="element-42">
                <span className="w-2 h-2 rounded-full bg-brand-orange" data-id="element-43"></span>{' '}
                pancakes
              </li>
              <li className="flex items-center gap-2" data-id="element-44">
                <span className="w-2 h-2 rounded-full bg-brand-orange" data-id="element-45"></span>{' '}
                budines
              </li>
              <li className="flex items-center gap-2" data-id="element-46">
                <span className="w-2 h-2 rounded-full bg-brand-orange" data-id="element-47"></span>{' '}
                galletitas
              </li>
            </ul>
            <div className="bg-brand-orange/10 p-4 rounded-xl border border-brand-orange/20" data-id="element-48">
              <p className="font-bold text-brand-orange text-sm" data-id="element-49">
                👉 Con frutas y verduras escondidas
              </p>
            </div>
          </motion.div>

          {/* Card 2 */}
          <motion.div className="bg-brand-cream rounded-2xl p-8 shadow-lg border border-brand-beige relative overflow-hidden" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} data-id="element-50">
            <div className="absolute top-0 left-0 w-full h-2 bg-brand-green" data-id="element-51"></div>
            <h3 className="text-2xl font-bold text-brand-darkGreen mb-6 flex items-center gap-2" data-id="element-52">
              <span data-id="element-53">🍝</span> ALMUERZOS Y CENAS
            </h3>
            <ul className="space-y-3 mb-6 text-lg font-medium text-gray-700" data-id="element-54">
              <li className="flex items-center gap-2" data-id="element-55">
                <span className="w-2 h-2 rounded-full bg-brand-green" data-id="element-56"></span>{' '}
                arroz
              </li>
              <li className="flex items-center gap-2" data-id="element-57">
                <span className="w-2 h-2 rounded-full bg-brand-green" data-id="element-58"></span>{' '}
                pastas
              </li>
              <li className="flex items-center gap-2" data-id="element-59">
                <span className="w-2 h-2 rounded-full bg-brand-green" data-id="element-60"></span>{' '}
                tartas
              </li>
              <li className="flex items-center gap-2" data-id="element-61">
                <span className="w-2 h-2 rounded-full bg-brand-green" data-id="element-62"></span>{' '}
                nuggets
              </li>
              <li className="flex items-center gap-2" data-id="element-63">
                <span className="w-2 h-2 rounded-full bg-brand-green" data-id="element-64"></span>{' '}
                croquetas
              </li>
              <li className="flex items-center gap-2" data-id="element-65">
                <span className="w-2 h-2 rounded-full bg-brand-green" data-id="element-66"></span>{' '}
                medallones
              </li>
            </ul>
            <div className="bg-brand-green/10 p-4 rounded-xl border border-brand-green/20" data-id="element-67">
              <p className="font-bold text-brand-green text-sm" data-id="element-68">
                👉 Ideales para vianda o freezer
              </p>
            </div>
          </motion.div>

          {/* Card 3 */}
          <motion.div className="bg-brand-cream rounded-2xl p-8 shadow-lg border border-brand-beige relative overflow-hidden" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3
        }} data-id="element-69">
            <div className="absolute top-0 left-0 w-full h-2 bg-brand-red" data-id="element-70"></div>
            <h3 className="text-2xl font-bold text-brand-darkGreen mb-6 flex items-center gap-2" data-id="element-71">
              <span data-id="element-72">🍎</span> SNACKS
            </h3>
            <p className="text-sm text-gray-500 mb-4 font-medium uppercase tracking-wider" data-id="element-73">
              Para completar sin pensar:
            </p>
            <ul className="space-y-3 text-lg font-medium text-gray-700" data-id="element-74">
              <li className="flex items-center gap-2" data-id="element-75">
                <span className="w-2 h-2 rounded-full bg-brand-red" data-id="element-76"></span>{' '}
                bocaditos
              </li>
              <li className="flex items-center gap-2" data-id="element-77">
                <span className="w-2 h-2 rounded-full bg-brand-red" data-id="element-78"></span>{' '}
                barritas
              </li>
              <li className="flex items-center gap-2" data-id="element-79">
                <span className="w-2 h-2 rounded-full bg-brand-red" data-id="element-80"></span>{' '}
                opciones dulces y saladas
              </li>
              <li className="flex items-center gap-2" data-id="element-81">
                <span className="w-2 h-2 rounded-full bg-brand-red" data-id="element-82"></span>{' '}
                snacks rápidos para llevar
              </li>
            </ul>
          </motion.div>
        </div>

        <motion.a href="https://comerfacil.shop/cart/44790229336179:1" className="block max-w-3xl mx-auto" initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} whileHover={{
        scale: 1.02
      }} data-id="element-83">
          <img src="https://cdn.magicpatterns.com/uploads/erE2UmoNuZbCcUFcBHnJtX/ChatGPT_Image_17_abr_2026,_13_40_49.png" alt="Qué incluye el ebook" className="w-full rounded-2xl shadow-2xl border-4 border-white" data-id="element-84" />
        </motion.a>
      </div>
    </section>;
}